import $ from 'jquery';

// ------------------------------
// **** jQuery destroy event ****
// ------------------------------

/**
 * Bind the destroy event on all elements that are removed with 'remove'
 * @author https://github.com/IndigoUnited/jquery.destroy-event/blob/master/lib/jquery.destroy-event.js
 */
// @ts-ignore Property '_author' does not exist on type
if (!$.cleanData || !$.cleanData._author) {
	// Detect if support is already added by third-party code
	let hasSupport;
	// Delete any third-party code using special "destroy" event
	// before testing, because it doesn't work correctly
	delete $.event.special.destroy;

	$('<div></div>').on('destroy', () => {
		hasSupport = true;
	}).remove();

	if (!hasSupport) {

		// Finally hook into jQuery to add support for the "destroy" event
		const oldClean = $.cleanData;

		$.cleanData = function(elems) {
			let data;
			let elem;
			let i;

			for (i = 0; (elem = elems[i]) != null; i += 1) {
				// Only trigger remove when necessary to save time
				// The flag _destroy_event_triggered is just to avoid trigger the destroy again
				// in cases like:
				//      $(elem).on('destroy', function () { $(elem).remove(); });
				//      $(elem).remove();
				// When the remove is called in the destroy handler it will not fire the destroy again.
				// @ts-ignore Property '_data' does not exist on type 'JQueryStatic'.
				data = $._data(elem);
				if (data && data.events && data.events.destroy && !data._destroy_event_triggered) {
					data._destroy_event_triggered = true;
					$(elem).triggerHandler('destroy');
				}
			}
			oldClean(elems);
		};
		// @ts-ignore Property '_author' does not exist on type
		$.cleanData._author = 'https://github.com/IndigoUnited/jquery.destroy-event/blob/master/lib/jquery.destroy-event.js';
	}
}